import React, { useState, useEffect } from 'react';

interface DebouncedInputProps {
  type?: string;
  min?: number;
  max?: number;
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
  placeholder?: string;
  className?: string;
  list?: string;
}

const DebouncedInput: React.FC<DebouncedInputProps> = React.memo(({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}) => {
  const [value, setValue] = useState<string | number>(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value, onChange, debounce]);

  return <input {...props} value={value} onChange={(e) => setValue(e.target.value)} />;
},
  (prevProps, nextProps) => {
    return (
      prevProps.value === nextProps.value &&
      prevProps.onChange === nextProps.onChange &&
      prevProps.debounce === nextProps.debounce
    );
  }
);

export default DebouncedInput;
